import { ChevronLeft, ChevronRight } from 'lucide-react';

type Props = {
  currentPage: number;
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
};

export default function Pagination({ currentPage, totalItems, itemsPerPage, onPageChange }: Props) {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const start = currentPage * itemsPerPage + 1;
  const end = Math.min((currentPage + 1) * itemsPerPage, totalItems);

  if (totalItems === 0) return null;

  return (
    <div className="flex flex-col items-center justify-between gap-3 sm:flex-row">
      <p className="text-sm text-navy-500 dark:text-navy-400">
        Mostrando <span className="font-medium text-navy-700 dark:text-navy-200">{start}–{end}</span> de{' '}
        <span className="font-medium text-navy-700 dark:text-navy-200">{totalItems}</span> resultados
      </p>

      <div className="flex items-center gap-2">
        <button
          type="button"
          disabled={currentPage === 0}
          onClick={() => onPageChange(currentPage - 1)}
          className="inline-flex items-center gap-1 rounded-lg border border-navy-200 px-3 py-2 text-sm font-medium text-navy-600 transition-colors hover:bg-navy-50 disabled:cursor-not-allowed disabled:opacity-40 dark:border-navy-700 dark:text-navy-300 dark:hover:bg-navy-800"
        >
          <ChevronLeft className="h-4 w-4" />
          Anterior
        </button>

        <span className="min-w-[3rem] text-center text-sm font-medium text-navy-700 dark:text-navy-200">
          {currentPage + 1} / {totalPages}
        </span>

        <button
          type="button"
          disabled={currentPage >= totalPages - 1}
          onClick={() => onPageChange(currentPage + 1)}
          className="inline-flex items-center gap-1 rounded-lg border border-navy-200 px-3 py-2 text-sm font-medium text-navy-600 transition-colors hover:bg-navy-50 disabled:cursor-not-allowed disabled:opacity-40 dark:border-navy-700 dark:text-navy-300 dark:hover:bg-navy-800"
        >
          Próximo
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
